import React from "react";
//outsource
import { Row, Col, InputNumber, Form } from "antd";

//components

const IncomeEftPos = ({ edit, eftpos, setEftPos }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (value) => {
    setEftPos(value);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item initialValue={0} name="eftpos">
      <InputNumber
        min={0}
        value={eftpos}
        onChange={handleChange}
        prefix="$"
        disabled={!edit}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      />
    </Form.Item>
  );
};

export default IncomeEftPos;
